import {
  createValidationResult,
  findObjectForPropertyInModelContext,
  IModelContext,
  IValidationResult,
  ModelItem,
  ValidationFunction
} from '@mng/model';
import { ITEM_GV_PERSONEN_DATA, ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN } from '../gvangebot.model.paths';
import { GvAngebotData, GvPerson, GvPersonenData } from '../gvangebot.model.types';
import { hasGvPersonTarife } from './logic/gvtarif-model.logic';
import { isElternteilVn } from './logic/gvperson-model.logic';
import { hasFzKontoChanged } from './logic/gvangebot-model.logic';

export const gvPersonenValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const gvPersonenData: GvPersonenData = modelContext.value;
  const gvPersonen: GvPerson[] = gvPersonenData.personen;

  // console.log('gvPersonenValidation - gvPersonen', gvPersonen);

  const anzahlVnDefinitions: number = gvPersonen.filter((currentGvPerson) => currentGvPerson.personRollen.vn).length;
  const vpDefinitions: GvPerson[] = gvPersonen.filter((currentGvPerson) => currentGvPerson.personRollen.vp);
  const anzahlVpDefinitions: number = gvPersonen.filter((currentGvPerson) => currentGvPerson.personRollen.vp).length;

  if (anzahlVnDefinitions !== 1) {
    return createValidationResult('personen', null, 'Es muss 1 VN definiert sein');
  }

  if (anzahlVpDefinitions === 0) {
    return createValidationResult('personen', null, 'Es muss mindestens 1 VP definiert sein');
  }

  const vpsOhneTarifeVorhanden = !!vpDefinitions.find((gvPerson: GvPerson) => !hasGvPersonTarife(gvPerson));

  if (vpsOhneTarifeVorhanden) {
    return createValidationResult('personen', null, 'VPs ohne Tarife sind vorhanden');
  }

  return null;
};

export function isBeziehungZuVnReadOnly(modelItem: ModelItem, modelContext: IModelContext): boolean {
  const gvAngebotData: GvAngebotData = findObjectForPropertyInModelContext(modelContext, ITEM_GV_PERSONEN_DATA);
  const gvPerson: GvPerson = findObjectForPropertyInModelContext(
    modelContext,
    ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN
  );

  return isElternteilVn(gvAngebotData, gvPerson.personBeziehungen);
}

export const gvFzKontoAenderungsDatumValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const gvAngebotData: GvAngebotData = modelContext.dataStack[0];
  const isVn = modelContext.dataStack[3].personRollen.vn;
  if (isVn && hasFzKontoChanged(gvAngebotData) && !gvAngebotData.vertragsAenderungsDatum) {
    return createValidationResult(
      'fzKontoAenderungsDatum',
      null,
      'Bei Änderungen des Gruppenvertragskontos muss ein Änderungsdatum angegeben werden'
    );
  }
  return null;
};

export const sozVerAnstaltenDeckungsPflicht = [83, 91, 92];
export function brauchtSchwangerschaftsDeckung(modelItem: ModelItem, modelContext: IModelContext): boolean {
  const gvPerson: GvPerson = findObjectForPropertyInModelContext(
    modelContext,
    ITEM_GV_PERSONEN_DATA_PERSONEN_STAMMDATEN
  );

  return sozVerAnstaltenDeckungsPflicht.includes(gvPerson.stammdaten.sozversanstalt);
}
